import React from 'react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-to-b from-green-50 to-white py-8 md:py-12 px-4 pt-[10px] pb-[10px] pl-[2px] pr-[2px] mt-[-80px] mb-[-80px]" data-id="element-355" data-mp="3oabvlgvlzyhx">
      <div className="max-w-5xl mx-auto" data-id="element-356" data-mp="3jcaeh1hqu993">
        <div className="text-center mb-12" data-id="element-357" data-mp="13t15rwfmttb">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-8 leading-tight" data-id="element-358" data-mp="12rrnrv2efdp"></h2>
        </div>
      </div>
    </section>;
}